export default __webpack_public_path__ + "static/media/SignIcon.7892eb69.svg";